import Model from "~/models/_Model";
import Course from "./Course";

export default class EspAltCourseRequest extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courseplanner";
  }

  // Set the resource route of the model
  resource() {
    return "esp-requests";
  }

  relations() {
    return {
      course_info: Course,
    };
  }

  // Computed Attributes
  get display_request_type() {
    return "Alternate Request";
  }

  get display_course_description() {
    if (!this.course_info) {
      return this.course;
    }
    return `${this.course}: ${this.course_info.DESCRIPTION_CLEAN}`;
  }
}
